import React, { Component } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
} from "react-router-dom";
import route from './routeTable';
import * as CookieService from './CookieService';
import HeaderComponent from './components/HeaderComponent';
import FooterComponent from './components/FooterComponent';
import MoonLoader from "react-spinners/MoonLoader";
import { css } from "@emotion/core";
import * as $ from 'jquery';
import { withTranslation, Trans } from 'react-i18next'
//WW-1231 WO State Restriction -Vishwa S
const override = css`
    display: block;
`;



export default class App extends Component {
    displayName = App.name
    constructor(props) {
        super(props);
        this.setCookie = this.setCookie.bind(this);

        this.state = {
            displayMessage: ""
        }
    };
    componentDidMount() {
        $("#cookie-panel").hide();
        let isCookiePresent = CookieService.getCookieValue("cookieAggrement");
        if (isCookiePresent == "") {
            $("#cookie-panel").show();
        }
        $(`#toastSuccessmessage`).addClass('hide')
    };
    setCookie = () => {
        CookieService.setCookieValues("cookieAggrement", 1, 30);
        $("#cookie-panel").hide();
    }
    

    toastSuccessMessage = (message) => {
        this.setState({ displayMessage: message });
        $(`#toastSuccessmessage`).removeClass('hide');
        setTimeout(() => {
            $(`#toastSuccessmessage`).addClass('hide');
        }, 5000);
    }

        //setTimeout = (function () { $(`#toast-message`).fadeOut(500, function () { $(this).remove(); }); }, 5000);



    render() {
        return (
            <React.Fragment>
                <div className="loader-position hide" id="SDILoader">
                    <MoonLoader color={"#E99A05"} size={100} css={override} loading={true} />
                    <p id="loaderMessage" className="loader-message"></p> {/*WW-1231 WO State Restriction -Vishwa S*/}
                </div>
                <div className="col-md-12 alert-panel" id="cookie-panel">
                    <p className="float-left cookie-info mb-0 mt-1">This website utilizes cookies and similar technologies for functionality and other purposes.
                         Your use of this website constitutes your acceptance of cookies.</p>
                    <button className="btn btn-primary custom-save-btn primary-btn float-right px-5 mr-3" onClick={this.setCookie}>Ok, Got it</button>
                </div>
                {/*WW-1229 Home tiles -Nandhini L*/}
                <div className="custom-toast" id='toastSuccessmessage'>
                    <div className="toast-body d-flex align-items-center">
                        <img
                            src="images/toast-icon-green.svg"
                            className="me-2"
                            alt="toast-icon-green"
                        />
                        <p><Trans>{this.state.displayMessage}</Trans></p>
                    </div>
                </div>
                <Router createElement={true} >
                    <HeaderComponent />
                    <FooterComponent />
                    {/*WW-1229 Home tiles -Nandhini L*/}                    <Switch>
                        {route.map(({ path, component: C, title }) =>
                            <Route key={path} path={path} render={(props) => <C {...props} title={title} toastSuccessMessage={this.toastSuccessMessage} />} />
                        )}
                    </Switch>
                </Router>

            </React.Fragment>
        );
    };
}
